// src/components/FormikInput.js

import React, { useEffect, useState } from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"
import { useDispatch } from "react-redux"

// #region actions
import { getContribuyentesBusqueda } from "../../../store/actions"
import { use } from "react"
// #endregion

// #region selectors
import {
  useContribuyentesLista,
  useContribuyentesIsLoadingContribuyentes,
} from "store/selectors"
// #endregion

const FormikInputRFC = ({
  label,
  name,
  max = 13,
  type = "text",
  placeholder,
  formik,
  onChange,
  mask, // Opcional: si usas InputMask
  showCharacterCounter = false,
  isLoading,
  ...props
}) => {
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region functions

  const handleBlurCustom = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const rfc = event.target.value

    // Solo envía la petición si no hay errores
    if (!formik.errors.hasOwnProperty("RFC")) {
      dispatch(
        getContribuyentesBusqueda({
          nombreSolicitud: "busqueda",
          Cadena_Busqueda: formik.values.RFC,
        })
      )
    }

    // Re-envia el evento
    formik.handleBlur(event)
  }

  // #endregion

  // #region const-selectors
  const listaContribuyentes = useContribuyentesLista()
  const isLoadingLista = useContribuyentesIsLoadingContribuyentes()
  // #endregion selectors

  // #region Internal States
  // #endregion

  // #region useEffects
  useEffect(() => {
    if (!isLoadingLista && listaContribuyentes.length > 0) {
      if (listaContribuyentes[0].RFC === formik.values.RFC) {
        formik.setFieldError("RFC", "RFC repetido!")
      }
    }
  }, [listaContribuyentes, isLoadingLista])

  // #endregion

  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      {!isLoadingLista ? (
        <>
          <Input
            type={type}
            name={name}
            id={name}
            placeholder={placeholder}
            value={formik.values[name]}
            onChange={onChange || formik.handleChange}
            onBlur={handleBlurCustom}
            invalid={formik.touched[name] && !!formik.errors[name]}
            maxLength={max} // Limita la entrada a max caracteres
            autoComplete="off"
            {...props}
          />{" "}
          {showCharacterCounter ? (
            <div className="text-end">
              {formik.values[name].length}/{max}
            </div>
          ) : null}
        </>
      ) : (
        <div>
          <p aria-hidden="true" className="mt-2">
            <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
          </p>
        </div>
      )}
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FormikInputRFC
